import { render } from "./MyPagesOrder.vue?vue&type=template&id=3348e08f"
import script from "./MyPagesOrder.vue?vue&type=script&lang=js"
export * from "./MyPagesOrder.vue?vue&type=script&lang=js"

import "./MyPagesOrder.vue?vue&type=style&index=0&id=3348e08f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__